<template @showVigentes="handleShowVigentes">
  <div class="card" style="background-color: #fbfbfb">
    <div class="card-block pt-4">
      <div class="form-group row pt-2">
        <div v-if="screenW >= 768" class="col-md-12">
          <b-card>
            <b-tabs
              content-class="mt-3"
              fill
              v-model="tabIndex"
              id="tabsAssociado"
              ref="bTabs"
            >
              <b-tab
                title="Follow-ups"
                class="col"
                @click="onLoadTabTabHistory"
              >
                <TabHistory
                  v-if="objSelected"
                  ref="TabHistory"
                  :documentRef="objSelected.pessoa.document"
                />
              </b-tab>
              <b-tab
                title="Ações do CRM"
                class="col"
                @click="onLoadTabTabHistory"
              >
                <TabHistoryCrm
                  v-if="objSelected"
                  ref="TabHistoryCrm"
                  :documentRef="objSelected.pessoa.document"
                />
              </b-tab>
              <b-tab
                title="Anotações Negativas"
                @click="onLoadTabNegativeAnnotations"
              >
                <TabNegativeAnnotations ref="TabNegativeAnnotations" />
              </b-tab>
              <b-tab title="Bens Associado" @click="onLoadTabBensAssociado">
                <TabBensAssociado ref="TabBensAssociado" />
              </b-tab>
              <b-tab title="Cheque" @click="onLoadTabBankCheck" v-if="false">
                <TabBankCheck ref="TabBankCheck" />
              </b-tab>
              <b-tab title="Cartão de crédito" @click="onLoadTabCreditCard">
                <TabCreditCard ref="TabCreditCard" />
              </b-tab>
              <b-tab
                title="Endividamento Sicoob"
                @click="onLoadTabIndebtednessSicoob"
              >
                <TabIndebtednessSicoob ref="TabIndebtednessSicoob" />
              </b-tab>
              <b-tab
                title="Endividamento SFN"
                @click="onLoadTabIndebtednessSFN"
              >
                <TabIndebtednessSFN ref="TabIndebtednessSFN" />
              </b-tab>
              <b-tab
                title="Garantia de Operações"
                @click="onLoadTabOperationsGuarantee"
              >
                <TabOperationsGuarantee ref="TabOperationsGuarantee" />
              </b-tab>
              <b-tab title="Grupo Econômico" @click="onLoadTabEconomicGroup">
                <TabEconomicGroup ref="TabEconomicGroup" />
              </b-tab>
              <b-tab
                v-if="isFuncionarioAndHasPermission"
                title="Movimentação Diária"
                @click="onLoadTabDailyMovement"
              >
                <TabDailyMovement ref="TabDailyMovement" />
              </b-tab>
              <b-tab
                title="Saldo Médio Captação"
                @click="onLoadTabAverageFundingBalance"
              >
                <TabAverageFundingBalance ref="TabAverageFundingBalance" />
              </b-tab>
              <b-tab
                title="Saldo Médio CCO"
                @click="onLoadTabAverageBalanceCCO"
              >
                <TabAverageBalanceCCO ref="TabAverageBalanceCCO" />
              </b-tab>
              <b-tab title="IAP" @click="onLoadTabIAP">
                <TabIAP ref="TabIAP" />
              </b-tab>
              <b-tab
                title="Captação Remunerada Diária"
                @click="onLoadTabCaptacaoRemuneradaDiaria"
              >
                <TabCaptacaoRemuneradaDiaria
                  ref="TabCaptacaoRemuneradaDiaria"
                />
              </b-tab>
              <b-tab
                title="Contratos Vigentes"
                @click="onLoadTabContratosVigentes"
              >
                <TabContratosVigentes ref="TabContratosVigentes" />
              </b-tab>
              <b-tab title="Conta Poupança" @click="onLoadTabContaPoupanca">
                <TabContaPoupanca ref="TabContaPoupanca" />
              </b-tab>
              <b-tab title="Conta Capital" @click="onLoadTabContaCapital">
                <TabContaCapital ref="TabContaCapital" />
              </b-tab>
              <b-tab title="Conta Corrente" @click="onLoadTabContaCorrente">
                <TabContaCorrente ref="TabContaCorrente" />
              </b-tab>
              <b-tab
                title="Carteira Consórcio"
                @click="onLoadTabCarteiraConsorcio"
              >
                <TabCarteiraConsorcio ref="TabCarteiraConsorcio" />
              </b-tab>
              <b-tab title="Carteira Seguros" @click="onLoadTabCarteiraSeguros">
                <TabCarteiraSeguros ref="TabCarteiraSeguros" />
              </b-tab>
              <b-tab title="Oportunidades" @click="onLoadTabOportunidades">
                <TabCardsAssociate ref="TabCardsAssociate" />
              </b-tab>
              <b-tab
                title="Margem Contribuição"
                @click="onLoadMargemContribuicao"
              >
                <TabMargemContribuicao ref="TabMargemContribuicao" />
              </b-tab>
              <b-tab title="Risco" @click="onLoadAssociateRisc">
                <TabAssociateRisc ref="TabAssociateRisc" />
              </b-tab>
              <b-tab title="Pix" @click="onLoadPix">
                <TabPix ref="TabPix" />
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
        <!-- MOBILE VIEW -->
        <div v-else class="col-md-12">
          <div class="accordion" role="tablist">
            <b-card no-body class="mb-1" ref="cardGroup">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-0
                @click="onLoadTabTabHistory"
              >
                <strong>Follow-ups</strong>
              </b-card-header>
              <b-collapse
                id="accordion-0"
                visible
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabHistory
                  v-if="objSelected"
                  ref="TabHistory"
                  :documentRef="objSelected.pessoa.document"
                />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-1
                @click="onLoadTabNegativeAnnotations"
              >
                <strong>Anotações Negativas</strong>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabNegativeAnnotations ref="TabNegativeAnnotations" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1" v-if="false">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-2
                @click="onLoadTabBankCheck"
              >
                <strong>Cheque</strong>
              </b-card-header>
              <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabBankCheck ref="TabBankCheck" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-creditcard
                @click="onLoadTabCreditCard"
              >
                <strong>Cartão de Crédito</strong>
              </b-card-header>
              <b-collapse
                id="accordion-creditcard"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabCreditCard ref="TabCreditCard" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-bensAssociado
                @click="onLoadTabBensAssociado"
              >
                <strong>Bens Associado</strong>
              </b-card-header>
              <b-collapse
                id="accordion-bensAssociado"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabBensAssociado ref="TabBensAssociado" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-3
                @click="onLoadTabIndebtednessSicoob"
              >
                <strong>Endividamento Sicoob</strong>
              </b-card-header>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabIndebtednessSicoob ref="TabIndebtednessSicoob" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-3
                @click="onLoadTabIndebtednessSFN"
              >
                <strong>Endividamento SFN</strong>
              </b-card-header>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabIndebtednessSFN ref="TabIndebtednessSFN" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-4
                @click="onLoadTabOperationsGuarantee"
              >
                <strong>Garantia de Operações</strong>
              </b-card-header>
              <b-collapse
                id="accordion-4"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabOperationsGuarantee ref="TabOperationsGuarantee" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-5
                @click="onLoadTabEconomicGroup"
              >
                <strong>Grupo Econômico</strong>
              </b-card-header>
              <b-collapse
                id="accordion-5"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabEconomicGroup ref="TabEconomicGroup" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-6
                @click="onLoadTabDailyMovement"
              >
                <strong>Movimentação Diária</strong>
              </b-card-header>
              <b-collapse
                id="accordion-6"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabDailyMovement ref="TabDailyMovement" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-7
                @click="onLoadTabAverageFundingBalance"
              >
                <strong>Saldo Médio Captação</strong>
              </b-card-header>
              <b-collapse
                id="accordion-7"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabAverageFundingBalance ref="TabAverageFundingBalance" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-8
                @click="onLoadTabAverageBalanceCCO"
              >
                <strong>Saldo Médio CCO</strong>
              </b-card-header>
              <b-collapse
                id="accordion-8"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabAverageBalanceCCO ref="TabAverageBalanceCCO" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-9
                @click="onLoadTabIAP"
              >
                <strong>IAP</strong>
              </b-card-header>
              <b-collapse
                id="accordion-9"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabIAP ref="TabIAP" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-10
                @click="onLoadTabCaptacaoRemuneradaDiaria"
              >
                <strong>Captação Remunerada Diária</strong>
              </b-card-header>
              <b-collapse
                id="accordion-10"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabCaptacaoRemuneradaDiaria
                  ref="TabCaptacaoRemuneradaDiaria"
                />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1" ref="cardContratosVigentes">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-11
                id="contratosVigentes"
                ref="contratosVigentes"
                @click="onLoadTabContratosVigentes"
              >
                <strong>Contratos Vigentes</strong>
              </b-card-header>
              <b-collapse
                id="accordion-11"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
                ref="contratosVigentesCollapse"
              >
                <TabContratosVigentes ref="TabContratosVigentes" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-12
                @click="onLoadTabContaPoupanca"
              >
                <strong>Conta Poupança</strong>
              </b-card-header>
              <b-collapse
                id="accordion-12"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabContaPoupanca ref="TabContaPoupanca" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-13
                @click="onLoadTabContaCapital"
              >
                <strong>Conta Capital</strong>
              </b-card-header>
              <b-collapse
                id="accordion-13"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabContaCapital ref="TabContaCapital" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-13
                @click="onLoadTabContaCorrente"
              >
                <strong>Conta Corrente</strong>
              </b-card-header>
              <b-collapse
                id="accordion-13"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabContaCorrente ref="TabContaCorrente" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-14
                @click="onLoadTabCarteiraConsorcio"
              >
                <strong>Carteira Consórcio</strong>
              </b-card-header>
              <b-collapse
                id="accordion-14"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabCarteiraConsorcio ref="TabCarteiraConsorcio" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-15
                @click="onLoadTabCarteiraSeguros"
              >
                <strong>Carteira Seguros</strong>
              </b-card-header>
              <b-collapse
                id="accordion-15"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabCarteiraSeguros ref="TabCarteiraSeguros" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-15
                @click="onLoadTabOportunidades"
              >
                <strong>Oportunidades</strong>
              </b-card-header>
              <b-collapse
                id="accordion-15"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabCardsAssociate ref="TabCardsAssociate" />
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 text-center"
                role="tab"
                v-b-toggle.accordion-15
                @click="onLoadMargemContribuicao"
              >
                <strong>Margem Contribuição</strong>
              </b-card-header>
              <b-collapse
                id="accordion-15"
                accordion="my-accordion"
                role="tabpanel"
                style="padding: 10px"
              >
                <TabMargemContribuicao ref="TabMargemContribuicao" />
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'

import TabBensAssociado from '@/views/private/associate/tabs/BensAssociado.vue'
import TabContaPoupanca from '@/views/private/associate/tabs/ContaPoupanca.vue'
import TabIndebtednessSFN from '@/views/private/associate/tabs/IndebtednessSFN.vue'
import TabIndebtednessSicoob from '@/views/private/associate/tabs/IndebtednessSicoob.vue'
import TabAverageBalanceCCO from '@/views/private/associate/tabs/averagebalancecco.vue'
import TabAverageFundingBalance from '@/views/private/associate/tabs/averagefundingbalance.vue'
import TabBankCheck from '@/views/private/associate/tabs/bankcheck.vue'
import TabContaCapital from '@/views/private/associate/tabs/capitalaccount.vue'
import TabCaptacaoRemuneradaDiaria from '@/views/private/associate/tabs/captacaoremuneradadiaria.vue'
import TabCarteiraConsorcio from '@/views/private/associate/tabs/carteiraconsorcio.vue'
import TabContaCorrente from '@/views/private/associate/tabs/contacorrente.vue'
import TabContratosVigentes from '@/views/private/associate/tabs/contratosvigentes.vue'
import TabCreditCard from '@/views/private/associate/tabs/creditcard.vue'
import TabDailyMovement from '@/views/private/associate/tabs/dailymovement.vue'
import TabAssociateRisc from '@/views/private/associate/tabs/debitRisc.vue'
import TabPix from '@/views/private/associate/tabs/pix.vue'
import TabEconomicGroup from '@/views/private/associate/tabs/economicgroup.vue'
import TabHistory from '@/views/private/associate/tabs/history.vue'
import TabHistoryCrm from '@/views/private/associate/tabs/historyCrm.vue'
import TabIAP from '@/views/private/associate/tabs/iap.vue'
import TabCarteiraSeguros from '@/views/private/associate/tabs/insurancewallet.vue'
import TabMargemContribuicao from '@/views/private/associate/tabs/margemcontribuicao.vue'
import TabNegativeAnnotations from '@/views/private/associate/tabs/negativeannotations.vue'
import TabOperationsGuarantee from '@/views/private/associate/tabs/operationsguarantee.vue'
import TabCardsAssociate from '@/views/private/associate/tabs/oportunidadesassociado.vue'

export default {
  name: 'AssociateDetailsTabs',
  mixins: [ActionsForm],
  data () {
    return {
      objSelected: null,
      tabIndex: 0,
      screenW: screen.width,
      patrimony: null
    }
  },
  components: {
    TabBankCheck,
    TabDailyMovement,
    TabEconomicGroup,
    TabIndebtednessSicoob,
    TabIndebtednessSFN,
    TabNegativeAnnotations,
    TabOperationsGuarantee,
    TabHistory,
    TabHistoryCrm,
    TabCreditCard,
    TabBensAssociado,
    TabAverageFundingBalance,
    TabAverageBalanceCCO,
    TabIAP,
    TabCaptacaoRemuneradaDiaria,
    TabContratosVigentes,
    TabContaPoupanca,
    TabContaCapital,
    TabContaCorrente,
    TabCarteiraConsorcio,
    TabCarteiraSeguros,
    TabCardsAssociate,
    TabMargemContribuicao,
    TabAssociateRisc,
    TabPix
  },
  computed: {
    averageFundingBalanceValue () {
      let result = 'R$ 0,00'
      if (this.averageFundingBalance) {
        let total = 0
        this.averageFundingBalance.forEach((x) => {
          total += x.valorSaldoFinal
        })
        result = Tools.formatMoneyBR(total)
      }
      return result
    },
    averageBalanceDioccoValue () {
      let result = 'R$ 0,00'
      if (this.averageBalanceDiocco) {
        let total = 0
        this.averageBalanceDiocco.forEach((x) => {
          total += x.valorSaldoMedio
        })
        result = Tools.formatMoneyBR(total)
      }
      return result
    },
    grossMonthlyIncome () {
      let result = 'R$ 0,00'
      if (this.objSelected) {
        result = Tools.formatMoneyBR(this.objSelected.rendaBrutaMensal)
      }
      return result
    },
    address () {
      let result = null
      if (this.objSelected && this.objSelected.endereco) {
        result = this.objSelected.endereco
      }
      return result
    },
    phones () {
      let result = null
      if (this.objSelected && this.objSelected.telefone) {
        result = this.objSelected.telefone
      }
      return result
    },
    isFuncionarioAndHasPermission () {
      if (this.objSelected && this.objSelected.funcionario) {
        if (this.hasRole(this.roles.VISUALIZACAO_INFOS_PRIVADAS_ASSOCIADOS)) {
          return true
        }
        return false
      }
      return true
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    onLoad () {},
    onCallDependences (document) {
      this.tabIndex = 0
      this.$refs.TabNegativeAnnotations.onLoadNegativeAnnotations(document)
    },
    onFormatMoney (value) {
      let result = 'R$ 0,00'
      if (value) {
        result = Tools.formatMoneyBR(value)
      }
      return result
    },
    handleShowVigentes () {
      this.$nextTick().then(() => {
        this.tabIndex = 13
        this.onLoadTabContratosVigentes()
      })
    },
    onCopyName () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.pessoa.nomeAssociado)
      }
    },
    onCopyDocument () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.pessoa.document)
      }
    },
    onCopyNumSisbr () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.pessoa.numSisbr)
      }
    },
    onCopy (value) {
      if (value) {
        var obj = this.$refs.myCopy
        obj.value = value
        obj.setAttribute('type', 'text')
        obj.select()
        document.execCommand('copy')
        toast.success(this.$lang.Common.Alerts.CopySuccess)
        obj.setAttribute('type', 'hidden')
      }
    },
    onLoadTabTabHistory () {
      if (this.objSelected) {
        this.$refs.TabHistory.onLoadAllFollowup(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabBankCheck () {
      if (this.objSelected) {
        this.$refs.TabBankCheck.onLoadBankCheck(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabDailyMovement () {
      if (this.objSelected) {
        this.$refs.TabDailyMovement.onLoadDailyMovement(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabEconomicGroup () {
      if (this.objSelected) {
        this.$refs.TabEconomicGroup.onLoadEconomicGroup(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabIndebtednessSicoob () {
      if (this.objSelected) {
        this.$refs.TabIndebtednessSicoob.onLoadIndebtedness(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabIndebtednessSFN () {
      if (this.objSelected) {
        this.$refs.TabIndebtednessSFN.onLoadIndebtedness(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabNegativeAnnotations () {
      if (this.objSelected) {
        this.$refs.TabNegativeAnnotations.onLoadNegativeAnnotations(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabOperationsGuarantee () {
      if (this.objSelected) {
        this.$refs.TabOperationsGuarantee.onLoadOperationsGuarantee(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabCreditCard () {
      if (this.objSelected) {
        this.$refs.TabCreditCard.onLoadCreditCard(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabBensAssociado () {
      if (this.objSelected) {
        this.$refs.TabBensAssociado.onLoadBensAssociado(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabAverageFundingBalance () {
      if (this.objSelected) {
        this.$refs.TabAverageFundingBalance.onLoadAverageFundingBalance(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabAverageBalanceCCO () {
      if (this.objSelected) {
        this.$refs.TabAverageBalanceCCO.onLoadAverageBalanceCCO(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabIAP () {
      if (this.objSelected) {
        this.$refs.TabIAP.onLoadIap(this.objSelected.pessoa.document)
      }
    },
    onLoadTabCaptacaoRemuneradaDiaria () {
      if (this.objSelected) {
        this.$refs.TabCaptacaoRemuneradaDiaria.onLoadCaptacaoRemuneradaDiaria(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabContratosVigentes () {
      if (this.objSelected) {
        this.$refs.TabContratosVigentes.onLoadContratosVigentes(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabContaPoupanca () {
      if (this.objSelected) {
        this.$refs.TabContaPoupanca.onLoadContaPoupanca(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabContaCapital () {
      if (this.objSelected) {
        this.$refs.TabContaCapital.onLoadContaCapital(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabContaCorrente () {
      if (this.objSelected) {
        this.$refs.TabContaCorrente.onLoadContaCorrente(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabCarteiraConsorcio () {
      if (this.objSelected) {
        this.$refs.TabCarteiraConsorcio.onLoadCarteiraConsorcio(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabCarteiraSeguros () {
      if (this.objSelected) {
        this.$refs.TabCarteiraSeguros.onLoadInsuranceWallet(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadTabOportunidades () {
      if (this.objSelected) {
        this.$refs.TabCardsAssociate.onLoadCardsAssociate(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadMargemContribuicao () {
      if (this.objSelected) {
        this.$refs.TabMargemContribuicao.onLoadMargemContribuicao(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadAssociateRisc () {
      if (this.objSelected) {
        this.$refs.TabAssociateRisc.onLoadAssociateRisc(
          this.objSelected.pessoa.document
        )
      }
    },
    onLoadPix () {
      if (this.objSelected) {
        this.$refs.TabPix.onLoadPix(
          this.objSelected.pessoa.document
        )
      }
    }
  }
}
</script>
<style scoped>
ul {
  list-style: none outside none;
  margin: 0;
  padding: 0;
}
li {
  float: left;
  margin: 0 30px;
}

.title-tab-configuration {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: left;
  color: #5d626c;
}
.title-tab-configuration a {
  text-decoration: underline;
  color: #04a791;
}
.close-card {
  text-align: right;
  display: block;
  right: 10px;
  position: absolute;
  top: 10px;
  z-index: 999;
}
card-header .nav.nav-tabs .nav-link,
.card-header .nav.nav-tabs .navbar .dropdown-toggle,
.navbar .card-header .nav.nav-tabs .dropdown-toggle {
  padding: 0.75rem 0.625rem;
  color: #04a791;
  border-top: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: 0px;
}
.p-1 {
  padding: 0.85rem !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/associate/components/associatedetailsTabs.vue